import React from 'react';
import { useAtomValue } from 'jotai';
import { locationAtom } from '../store/location';
import { FormattedMessage } from 'react-intl';

export const LocationLabel = (props: { locationId?: number }) => {
	const l = useAtomValue(locationAtom(props.locationId ?? 0));
	const msg = (
		<FormattedMessage
			defaultMessage="{locationIcon} {locationName}"
			id="tHAOXS"
			values={{ locationIcon: l?.emoji, locationName: l?.post_title }}
		/>
	);
	const url = l?.url ?? '';
	// console.log(url, l);
	return url != '' ? (
		<a
			href={l?.url}
			onClick={(e) => e.stopPropagation()}
			target="_blank"
			rel="noreferrer"
		>
			{msg}
		</a>
	) : (
		msg
	);
};
